import  _ from 'lodash'

export function getSum(transtion, type){
    let sum = _(transtion)
                .groupBy("type")
                .map((obj,key)=>{
                   // if(!type) return parseInt(_.sumBy(obj,'amount')) 
                    if(!type) return _.sumBy(obj.map(v=>parseInt(v.amount) ))                    
                   
                    return{
                        'type': key,
                        'color': obj[0].color,
                         'total': _.sumBy(obj.map(e=> parseInt(e.amount))) 
                        //  'total': parseInt(_.sumBy(obj,'amount')) 
                        
                      }                   
                    
                })
                .value()
                
                ;
                
    return sum
}
 export function getLabels(transtion){
    let amonutSum = getSum(transtion,'type')
    let amountTotal = parseInt(_.sum(getSum(transtion))) 
    let percent =_(amonutSum)
                    .map(obj=> _.assign(obj,{percent:(100 * obj.total ) / amountTotal}))
                    .value()
    return percent
}

export function chart_data(transtion, costom){
    let bg =_.map(transtion,a=> a.color)
    bg=_.uniq(bg)
    //console.log(bg);
    let datavalue = getSum(transtion)

    const config={
        data:{
          datasets: [{
            data: datavalue,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)'
            ],
            hoverOffset: 4,
            borderRadius:30,
            spacing:10
          }]
        },
        options:{
          cutout:110
        }
      }
      return costom??config
}

export function getTotal(transtion){
    return parseInt(_.sum(getSum(transtion))) 
}




